import { createAddObjectKey } from '@/utils/data-utils';

const clients = {};

const addClient = createAddObjectKey(clients, 'key');

const dreamworks = {
  key: 'dreamworks',
  name: 'Dreamworks',
  logo: require('../assets/logos/dreamworks.svg'),
  logoWhite: require('../assets/logos/dreamworks_white.svg'),
  href: null,
};

addClient(dreamworks);

const eb = {
  // key: 'evelyn-bobbie',
  key: 'eb',
  name: 'Evelyn & Bobbie',
  logo: require('../assets/logos/eb.svg'),
  logoWhite: require('../assets/logos/eb_white.svg'),
  href: null,
};

addClient(eb);

const hp = {
  // key: 'hewlett-packard',
  key: 'hp',
  name: 'HP',
  logo: require('../assets/logos/hp.svg'),
  logoWhite: require('../assets/logos/hp_white.svg'),
  href: null,
};

addClient(hp);

const jaguar = {
  key: 'jaguar',
  name: 'Jaguar',
  logo: require('../assets/logos/jaguar.svg'),
  logoWhite: require('../assets/logos/jaguar_white.svg'),
  href: null,
};

addClient(jaguar);

const landrover = {
  // key: 'land-rover',
  key: 'landrover',
  name: 'Landrover',
  logo: require('../assets/logos/landrover.svg'),
  logoWhite: require('../assets/logos/landrover_white.svg'),
  href: null,
};

addClient(landrover);

const moovel = {
  key: 'moovel',
  name: 'Moovel',
  logo: require('../assets/logos/moovel.svg'),
  logoWhite: require('../assets/logos/moovel_white.svg'),
  href: null,
};

addClient(moovel);

const outcome = {
  // key: 'outcome-md',
  key: 'outcome',
  name: 'Outcome',
  logo: require('../assets/logos/outcome.svg'),
  logoWhite: require('../assets/logos/outcome_white.svg'),
  href: null,
};

addClient(outcome);

const particleDesign = {
  // key: 'particle-design',
  key: 'particleDesign',
  name: 'Particle Design',
  logo: require('../assets/logos/particle.svg'),
  logoWhite: require('../assets/logos/particle_white.svg'),
  href: null,
};

addClient(particleDesign);

const regence = {
  key: 'regence',
  name: 'Regence',
  logo: require('../assets/logos/regence.svg'),
  logoWhite: require('../assets/logos/regence_white.svg'),
  href: null,
};

addClient(regence);

const samsung = {
  key: 'samsung',
  name: 'Samsung',
  logo: require('../assets/logos/samsung.svg'),
  logoWhite: require('../assets/logos/samsung_white.svg'),
  href: null,
};

addClient(samsung);

const vh1 = {
  key: 'vh1',
  // key: 'virgin-hyperloop-one',
  name: 'Virgin Hyperloop One',
  logo: require('../assets/logos/vh1.svg'),
  logoWhite: require('../assets/logos/vh1_white.svg'),
  href: null,
};

addClient(vh1);

const vrMotion = {
  key: 'vrMotion',
  name: 'VR Motion',
  logo: require('../assets/logos/vr_motion.svg'),
  logoWhite: require('../assets/logos/vr_motion_white.svg'),
  href: null,
};

addClient(vrMotion);

const honeywell = {
  key: 'honeywell',
  name: 'Honeywell',
  logo: require('../assets/logos/honeywell.svg'),
  logoWhite: require('../assets/logos/honeywell_white.svg'),
  href: null,
};

addClient(honeywell);

const skyryse = {
  key: 'skyryse',
  name: 'Skyryse',
  logo: require('../assets/logos/skyryse.svg'),
  logoWhite: require('../assets/logos/skyryse_white.svg'),
  href: null,
};

addClient(skyryse);

const mentorSiemens = {
  key: 'mentorSiemens',
  name: 'Mentor Siemens',
  logo: require('../assets/logos/mentor-siemens.svg'),
  logoWhite: require('../assets/logos/mentor-siemens_white.svg'),
  href: null,
};

addClient(mentorSiemens);

const gm = {
  key: 'gm',
  name: 'GM',
  logo: require('../assets/logos/gm.svg'),
  logoWhite: require('../assets/logos/gm_white.svg'),
  href: null,
};

addClient(gm);

export default clients;



// WEBPACK FOOTER //
// ./src/data/clients.js